<template>
  <div>

    <div class="remark-header">绿贝小助手7.72</div>

    <div>{{ testText }}</div>
    <div id="text" v-if="remark" class="remark-container">
      <p v-html="highlightedB" clsss="no-wrap"></p>
    </div>


    <div v-if="QrodeUrl || chezhengUrl || jiaoqiangUrl || shangyeUrl" class="image-wrapper">
      <img v-if="chezhengUrl" :src="chezhengUrl" alt="车证" class="auto-fit-image">
      <img v-if="jiaoqiangUrl" :src="jiaoqiangUrl" alt="交强险" class="auto-fit-image">
      <img v-if="shangyeUrl" :src="shangyeUrl" alt="商业险" class="auto-fit-image">
      <img v-if="QrodeUrl" :src="QrodeUrl" alt="交款码" class="auto-fit-image">
      <a v-if="QrodeUrllink" :href="QrodeUrllink" target="_blank"
        rel="noopener noreferrer" style="display: block; margin-top: 8px; color: #1890ff; text-decoration: underline;">
        打开二维码
      </a>
    </div>

    <div v-if="button1data">
      <pre class="remark-container">{{ button1data }}</pre>
    </div>

    <p v-if="error">{{ error }}</p>
    <p v-if="loading">尝试获取数据中...</p>
    <button ref="jiaoguanButton" style="margin-right: 10px;" @click="fetchData(carNo)">交管</button>
    <button ref="hetongButton" style="margin-right: 10px;" @click="fetchHTData(carNo)">备案查询</button>
    <button ref="qunButton" style="margin-right: 10px;" @click="createGroupChat()">建退车群</button>
    <button ref="zhangdanButton" style="margin-right: 10px;" @click="fetchZDData(carNo)">账单</button>
    <button ref="dingweiButton" style="margin-right: 10px;" @click="fetchDWData(carNo)">定位</button>
    <button ref="mileButton" style="margin-right: 10px;" @click="fetchMileData(carNo)">里程</button>
    <button ref="czGPSButton" style="margin-right: 10px;" @click="fetchCZGPSData(carNo)">车证GPS</button>
    <button ref="qRButton" style="margin-right: 10px;" @click="fetchQrcode(orderid)">交款码</button>
    <button ref="qRRButton" style="margin-right: 10px;" @click="refetchQrcode(carNo)">刷新</button>
    <button ref="yimatongqRButton" style="margin-right: 10px;" @click="fetchyimatongQrcode(orderid)">一码通</button>

    <!-- 查询奖励按钮 -->
    <button ref="noweizhangButton" style="margin-right: 10px;" @click="() => fetchNoweizhangData(orderid)">查询奖励</button>

    <!-- 保单车证按钮 -->
    <button ref="baodanButton" style="margin-right: 10px;" @click="fetchWarrantyStatus(carNo)">车证保单</button>

    <!-- 错误提示 -->
    <div v-if="error" style="color: red;">{{ error }}</div>

    <!-- 无数据提示 -->
    <div v-if="recordsList.length === 0 && !loading && noweizhangButton.value.disabled">
      暂无奖励信息，请联系财务核对。
    </div>

    <!-- 记录列表 -->
    <div v-for="record in recordsList" :key="record.id" class="record-item">
      <p>
        {{ record.billName }} - {{ record.status }} - {{ record.operatorStatus }}<br />
        {{ record.billStart }}~{{ record.billEnd }}：{{ record.value }}
      </p>
      <span v-if="record.remark">备注：{{ record.remark }}</span>
      <button @click="openDialog(record.id, record.remark || '')">
        编辑备注
      </button>
      <hr />
    </div>

    <!-- 对话框（简易版，可用 Element Plus / Naive UI 等替换） -->
    <div v-if="dialogVisible" class="dialog-overlay">
      <div class="dialog">
        <h3>填写备注</h3>
        <input v-model="remarkInput" type="text" placeholder="请输入备注"
          style="width: 100%; padding: 8px; margin: 10px 0;" />
        <div>
          <button @click="confirmUpdate" :disabled="updating">确定</button>
          <button @click="dialogVisible = false">取消</button>
        </div>
      </div>
    </div>




  </div>

</template>

<script setup>
import {onMounted, ref, computed } from 'vue';
import axios from 'axios';
import * as ww from '@wecom/jssdk'

const remark = ref('')
const orderid = ref('')
const carNo = ref('')
const singdata = ref('')
const userid = ref('')
const loading = ref(true);
const error = ref(null);
const testText = ref('')
const button1data = ref('');
const QrodeUrl = ref('');
const QrodeUrllink = ref('');
const chezhengUrl = ref(''); // 车证图片URL
const jiaoqiangUrl = ref(''); // 交强险图片URL
const shangyeUrl = ref(''); // 商业险图片URL
const comUsername = ref('')
const code=ref('')
let isInitialized = false;
// 创建一个锁机制来确保初始化过程的唯一性
let initializationPromise = null;
const jiaoguanButton = ref(null);
const hetongButton = ref(null);
const noweizhangButton = ref(null);
const czGPSButton = ref(null);
const dingweiButton = ref(null);
const mileButton=ref(null);
const qRButton = ref(null);
const qRRButton = ref(null);
const yimatongqRButton = ref(null);
const zhangdanButton = ref(null);
const qunButton = ref(null);
const baodanButton = ref(null);

// 存储原始记录数据（用于渲染和更新）
const recordsList = ref([]);

// 控制对话框
const dialogVisible = ref(false);
const currentRecordId = ref(null); // 当前要编辑的记录 ID
const remarkInput = ref('');      // 输入框内容


const updating = ref(false);

const openDialog = (id, remark) => {
  currentRecordId.value = id;
  remarkInput.value = remark;
  dialogVisible.value = true;
};

const confirmUpdate = async () => {
  if (updating.value) return;

  updating.value = true;
  try {
    const payload = {
      id: currentRecordId.value,
      remark: remarkInput.value.trim(),
      operator: comUsername.value // 或从登录信息获取
    };

    await axios.put('https://life.greenbaytrip.com:8080/api/reduction', payload, {
      headers: { 'Content-Type': 'application/json' }
    });

    // ✅ 更新成功：刷新本地数据（避免重新请求）
    const index = recordsList.value.findIndex(r => r.id === currentRecordId.value);
    if (index !== -1) {
      recordsList.value[index].remark = remarkInput.value.trim();
    }

    dialogVisible.value = false;
    alert('备注更新成功！');
  } catch (err) {
    alert('更新失败: ' + (err.response?.data?.message || err.message));
  } finally {
    updating.value = false;
  }
};

// jiaoguan数据
const fetchData = async (button) => {
  loading.value = true;
  error.value = null;
  jiaoguanButton.value.disabled = true;
  try {
    const response = await axios.get(`https://xzs.lbzuche.cn/122/${button}?comUsername=${comUsername.value}`);
    button1data.value = button1data.value + '\n-----------------\n' + response.data;
  } catch (err) {
    error.value = `请求失败: ${err.message}`;
  } finally {
    loading.value = false;
  }
};

// hetong数据
const fetchHTData = async (button) => {
  loading.value = true;
  error.value = null;
  hetongButton.value.disabled = true;
  try {
    const response = await axios.get(`https://xzs.lbzuche.cn/sohetong/${button}?comUsername=${comUsername.value}`);
    button1data.value = button1data.value + '\n-----------------\n' + response.data;
  } catch (err) {
    error.value = `请求失败: ${err.message}`;
  } finally {
    loading.value = false;
  }
};

// 无违章奖励数据
const fetchNoweizhangData = async (orderid) => {
  loading.value = true;
  error.value = null;
  noweizhangButton.value.disabled = true;

  try {
    // const response = await axios.get(
    //   `https://life.greenbaytrip.com:8080/api/reduction?page=1&size=100&carNo=${carNo}&orderStatusStr=%E7%A7%9F%E8%B5%81%E4%B8%AD`
    // );
    const response = await axios.get(
      `https://life.greenbaytrip.com:8080/api/reduction?page=1&size=100&orderId=${orderid}`
    );
    recordsList.value = response.data?.data?.records || [];
  } catch (err) {
    error.value = `请求失败: ${err.message}`;
    recordsList.value = [];
  } finally {
    loading.value = false;
    // noweizhangButton.value.disabled = false;
  }
};


// 定位数据
const fetchDWData = async (button) => {
  loading.value = true;
  error.value = null;
  dingweiButton.value.disabled = true;
  try {
    const response = await axios.get(`https://xzs.lbzuche.cn/carapilocation/${button}?comUsername=${comUsername.value}`);
    button1data.value = button1data.value + '\n-----------------\n' + response.data;
  } catch (err) {
    error.value = `请求失败: ${err.message}`;
  } finally {
    loading.value = false;
  }
};

// 里程数据
const fetchMileData = async (button) => {
  loading.value = true;
  error.value = null;
  mileButton.value.disabled = true;
  try {
    const response = await axios.get(`https://xzs.lbzuche.cn/carapimile/${button}?comUsername=${comUsername.value}`);
    button1data.value = button1data.value + '\n-----------------\n' + response.data;
  } catch (err) {
    error.value = `请求失败: ${err.message}`;
  } finally {
    loading.value = false;
  }
};

// 车证gps数据
const fetchCZGPSData = async (button) => {
  loading.value = true;
  error.value = null;
  czGPSButton.value.disabled = true;
  try {
    const response = await axios.get(`https://xzs.lbzuche.cn/carczgps/${button}?comUsername=${comUsername.value}`);
    button1data.value = button1data.value + '\n-----------------\n' + response.data;
  } catch (err) {
    error.value = `请求失败: ${err.message}`;
  } finally {
    loading.value = false;
  }
};

// 交款码
const fetchQrcode = async (button) => {
  loading.value = true;
  error.value = null;
  qRButton.value.disabled = true;
  try {
    const response = await axios.get(`https://xzs.lbzuche.cn/qrcode/${button}?comUsername=${comUsername.value}`);
    // button1data.value = button1data.value + '\n-----------------\n' + response.data;
    console.log('QrodeUrl', response.data);
    QrodeUrl.value = response.data
  } catch (err) {
    error.value = `请求失败: ${err.message}`;
  } finally {
    loading.value = false;
  }
};


// 一码通
const fetchyimatongQrcode = async () => {
  loading.value = true;
  error.value = null;
  yimatongqRButton.value.disabled = true;
  try {
    const response = await axios.get(`https://life.greenbaytrip.com:8080/api/order/generate2?orderId=${orderid.value}`);
    // console.log('yimatongqrcode', response.data);
    QrodeUrl.value = response.data['data']['QrcodeUrl']
    QrodeUrllink.value = response.data['data']['url']
  } catch (err) {
    error.value = `请求失败: ${err.message}`;
  } finally {
    loading.value = false;
  }
};

// 刷新交款码
const refetchQrcode = async (button) => {
  loading.value = true;
  error.value = null;
  qRRButton.value.disabled = true;
  try {
    const response = await axios.get(`https://xzs.lbzuche.cn/reqrcode/${button}?comUsername=${comUsername.value}`);
    // button1data.value = button1data.value + '\n-----------------\n' + response.data;
    console.log('QrodeUrl', response.data);
    QrodeUrl.value = response.data
  } catch (err) {
    error.value = `请求失败: ${err.message}`;
  } finally {
    loading.value = false;
    qRRButton.value.disabled = false;
  }
};

// 账单数据
const fetchZDData = async (button) => {
  loading.value = true;
  error.value = null;
  zhangdanButton.value.disabled = true;
  try {
    const response = await axios.get(`https://xzs.lbzuche.cn/carapizhangdan/${button}?comUsername=${comUsername.value}&orderid=${orderid.value}`);
    button1data.value = button1data.value + '\n-----------------\n' + response.data;
  } catch (err) {
    error.value = `请求失败: ${err.message}`;
  } finally {
    loading.value = false;
  }
};



const getConfigSignature = async () => {
  // error.value +='...getConfigSignature1'
  if (!singdata.value) return null;
  // error.value +='getConfigSignature...'
  return {
    timestamp: singdata.value['timestamp'],
    nonceStr: singdata.value['nonceStr'],
    signature: singdata.value['signatureCom']
  }
}

const getAgentConfigSignature = async () => {
  if (!singdata.value) return null;
  // error.value +='getAgentConfigSignature...'
  return {

    timestamp: singdata.value['timestamp'],
    nonceStr: singdata.value['nonceStr'],
    signature: singdata.value['signatureAG']
  }
}

// 添加延时函数
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// 用于追踪 signnew 请求的 Promise
let signRequestPromise = null;

// 初始化企业微信SDK
const initializeWW = async () => {
  // 如果已有签名数据，直接返回
  if (singdata.value) {
    console.log('已有签名数据，跳过初始化');
    return;
  }

  // 如果已有请求在进行中，等待它完成
  if (signRequestPromise) {
    console.log('签名请求正在进行中，等待完成...');
    return signRequestPromise;
  }

  // 创建新的请求 Promise
  signRequestPromise = (async () => {
    try {
      console.log('开始初始化企业微信SDK...');

      const response = await axios.get('https://xzs.lbzuche.cn/signnew/');
      singdata.value = response.data;

      ww.register({
        corpId: 'ww2fcd8b58ddfada9e',
        agentId: '1000032',
        jsApiList: ['getCurExternalContact', 'openEnterpriseChat', 'sendChatMessage'],
        getConfigSignature,
        getAgentConfigSignature,
        debug: true
      });
      // 添加短暂延时确保SDK加载完成
      await delay(200);
      console.log('企业微信SDK注册完成');
    } catch (err) {
      console.error('初始化失败:', err);
      error.value += '初始化企业微信SDK失败2: ' + err.message;
      throw err;
    } finally {
      // 请求完成后清除 Promise 引用
      signRequestPromise = null;
    }
  })();

  return signRequestPromise;
}


// 创建退车群
const createGroupChat = async () => {
  loading.value = true;
  error.value = null;
  qunButton.value.disabled = true;
  try {
    console.log('创建退车群...');
    // 获取当前日期
    const currentDate = new Date();
    // await delay(3000);
    // 获取年份和月份
    const year = String(currentDate.getFullYear()).slice(-2);
    const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以加1
    const result = "-" + year + "-" + month + '退车群';
    ww.openEnterpriseChat({
      groupName: carNo.value + result,
      userIds: [
        comUsername.value,
        // '17790264460',
        'hehai'
      ],
      externalUserIds: [
        // 'wmEAlECwAAHrbWYDOK5u3Bf13xlYDAAA',
        userid.value
      ]
    })
    console.log('创建退车群完成');

  } catch (err) {
    console.error('创建退车群失败:', err);
    error.value = '创建退车群失败: ' + err.message;
    throw err;
  } finally {
    loading.value = false;
  }
};



// 获取外部用户ID
const getUserId = async () => {
  try {
    return new Promise((resolve, reject) => {
      ww.getCurExternalContact({
        success(result) {
          console.log('成功获取外部用户ID:', result['userId']);
          resolve(result['userId']);
        },
        fail(result) {
          console.error('获取用户ID失败:', result);
          reject(new Error('获取用户ID失败'));
        }
      });
    });
  } catch (err) {
    console.error('获取用户ID失败:', err);
    error.value = '获取用户ID失败: ' + err.message;
    throw err;
  }
}

// 获取用户备注信息
const fetchUser = async () => {
  if (!userid.value) {
    console.log('未获取到用户ID，跳过获取备注信息');
    return;
  }
  loading.value = true;
  try {
    const url = `https://xzs.lbzuche.cn/userremark2/${userid.value}?comuserid=${encodeURIComponent(localStorage.getItem('comUsername'))}`;
    const response = await axios.get(url);
    let res = response.data;

    remark.value = res['msg'];
    orderid.value = res['orderid'];
    carNo.value = res['carno'];
    console.log('成功获取用户备注信息:', response.data);
  } catch (err) {
    console.error('获取用户备注信息失败:', err);
    error.value += '获取用户备注信息失败2:' + err.message + err.response;
    error.value += err.config + '-----' + err.stack;
  } finally {
    loading.value = false;
  }
}


function setIsInitializing(value) {
  sessionStorage.setItem('app_initializing', value.toString());
}

async function initApp() {
  // 如果已经初始化完成，直接返回
  if (isInitialized) {
    console.log('应用已初始化，跳过重复执行');
    return Promise.resolve();
  }
  
  // 如果正在初始化过程中，返回正在进行的Promise
  if (initializationPromise) {
    console.log('初始化已在进行中，等待完成...');
    return initializationPromise;
  }
  

  console.log('开始初始化应用...');
  
  // 设置初始化标志
  setIsInitializing(true);
  
  // 创建初始化Promise并保存引用
  initializationPromise = (async () => {
    try {
      // 1. 初始化企业微信SDK
      await initializeWW();
      
      // 2. 尝试多次获取外部用户ID
      let retryCount = 0;
      const maxRetries = 3;
      let userId = null;

      while (retryCount < maxRetries && !userId) {
        try {
          userId = await getUserId(); //获取本人ID
          console.log(`第 ${retryCount + 1} 次尝试获取用户ID成功:`, userId);
        } catch (err) {
          console.log(`第 ${retryCount + 1} 次获取用户ID失败:`, err.message);
          retryCount++;
          if (retryCount < maxRetries) {
            console.log(`等待1秒后重试...`);
            await delay(1000);
          }
        }
      }

      if (userId) {
        userid.value = userId;
        // console.log('外部用户ID获取完成:', userId);
        await fetchUser();
        comUsername.value=encodeURIComponent(localStorage.getItem('comUsername')) //#call_backhtml赋值,这个没有不晓得哪来的
        // 只有在完全成功的情况下才标记为已初始化
        isInitialized = true;
        sessionStorage.setItem('app_initialized', 'true');
        console.log('初始化成功完成');
      } else {
        userid.value = '初始化-没有获取用户ID';
        console.log('达到最大重试次数仍未获取到用户ID');
        throw new Error('无法获取用户ID');
      }
    } catch (err) {
      console.error('初始化流程失败:', err);
      error.value += typeof err === 'string' ? err : '初始化流程失败2-' + String(err);
      
      // 初始化失败时不标记为已初始化
      isInitialized = false;
      
      // 清空初始化Promise，允许后续重试
      initializationPromise = null;
      // setIsInitializing(false);
    } finally {
      loading.value = false;
      // 确保清除初始化标志
      // setIsInitializing(false);
    }
  })();
  
  // 返回初始化Promise
  return initializationPromise;
}

// 初始化流程
onMounted(async () => {
  const url = new URL(window.location.href)
  // const authCode = url.searchParams.get('code')
  const authCode = localStorage.getItem('oauth_code')
  console.log('url:', url,'authcode:', authCode)
  // const cleanUrl = window.location.origin + window.location.pathname
  // if(!url){await initApp()}
  if (authCode) {
    // 1. 保存 code（用于发送给后端）
    code.value = authCode
    console.log('提取到 code:', code.value)
    await initApp()

    return
  } else {
    console.log('干净页面，初始化应用')

    return
  }

});




// ========== 保单车证相关功能 ==========

// 获取车证文件状态并自动下载车证图片
const fetchWarrantyStatus = async (carno) => {
  if (!carno) {
    error.value = '车牌号为空';
    return;
  }
  
  baodanButton.value.disabled = true;
  
  try {
    // 车证图片地址
    chezhengUrl.value = `https://life-1328614890.cos.ap-chengdu.myqcloud.com/车证/${carno}.jpg`
    
    // 交强险图片地址
    jiaoqiangUrl.value = `https://xzs.lbzuche.cn/pdfToImage?carNo=${encodeURIComponent(carno)}&type=jiaoqiang`
    
    // 商业险图片地址
    shangyeUrl.value = `https://xzs.lbzuche.cn/pdfToImage?carNo=${encodeURIComponent(carno)}&type=shangye`
    
    // 尝试请求交强险PDF验证是否存在
    try {
      await axios.get(`https://xzs.lbzuche.cn/pdfToImage`, {
        params: { carNo: carno, type: 'jiaoqiang' },
        responseType: 'blob'
      });
    } catch (err) {
      console.log('获取交强险失败:', err.message)
      jiaoqiangUrl.value = '' // 清空交强险图片
    }
    
    // 尝试请求商业险PDF验证是否存在
    try {
      await axios.get(`https://xzs.lbzuche.cn/pdfToImage`, {
        params: { carNo: carno, type: 'shangye' },
        responseType: 'blob'
      });
    } catch (err) {
      console.log('获取商业险失败:', err.message)
      shangyeUrl.value = '' // 清空商业险图片
    }
  } catch (err) {
    console.log('获取车证信息失败:', err.message)
  }

};

const highlightedB = computed(() => {
  if (!comUsername.value || !remark.value.includes(comUsername.value)) {
    return remark.value;
  }

  const regex = new RegExp(comUsername.value, 'gi');
  return remark.value.replace(regex, match => `<span class="highlight">${match}</span>`);
});

</script>

<style>
/* 容器样式 */
.remark-container {
  background-color: #f9f9f9;
  /* 浅灰色背景 */
  border: 1px solid #ddd;
  /* 边框 */
  border-radius: 8px;
  /* 圆角 */
  padding: 16px;
  /* 内边距 */
  max-width: 600px;
  /* 最大宽度 */
  margin: 20px auto;
  /* 水平居中 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  /* 阴影效果 */
  white-space: pre-wrap;
  /* 保留空白符序列，并正常地进行换行 */
  font-size: 16px;
  /* font-weight: bold; */
}

.highlight {
  color: red;
}

/* 标题样式 */
.remark-header {
  font-size: 18px;
  /* 字体大小 */
  font-weight: bold;
  /* 加粗 */
  color: #333;
  /* 深灰色字体 */
  margin-bottom: 8px;
  /* 下边距 */
}

.no-wrap {
  white-space: nowrap;
}

.image-wrapper {
  width: 100%;
  padding: 20px 0;
  text-align: center;
}

.auto-fit-image {
  width: 70%;
  height: auto;
  max-width: 100%;
  display: inline-block;
  border-radius: 8px;
}

button {
  /* padding: 10px 20px;
  font-size: 16px; */
  cursor: pointer;
  background-color: #007bff;
  color: white;
  border: none;
  padding: 6px 12px;
  font-size: 14px;
  height: 28px;
  min-width: 50px;
  border-radius: 4px;
  margin-right: 10px;
  margin-top: 5px;
  margin-bottom: 3px;
}

button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}


.record-item {
  margin: 10px 0;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 4px;
}

.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 300px;
}

</style>
